module.exports = __webpack_public_path__ + "static/img/3.c9546bc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imges/atlas/drilling/3.jpg
// module id = 3ksm
// module chunks = 1